import { useContext, useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import Select from 'components/common/Select/Select'
import MainLogo from 'components/assets/icons/MainLogo'
import style from './CoLabelSwitch.module.scss'

const CoLabelSwitch = ({className, styles, displayName}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [ options, setOptions ] = useState([])
  const { color, logo, adhesions, contractTypeName, setContract } = useContext(ClientContext)

  const onChange = (datas) => {
    // If user got into a contract page or claim then go back to their own start page
    const match = pathname.match(/([\w-]+)\/.+/)
    if (match) navigate('/'+match[1])

    // Find and set the selection
    const choice = options.find( opt => (
      opt.contractTypeId === datas.value.contractTypeId && 
      opt.partnerId === datas.value.partnerId && 
      opt.distributorId === datas.value.distributorId
    ))

    setContract(choice)
  }

  useEffect( () => {
    // Add adhesions into the option array (got a loop using adhesions directly)
    const setDatas = async () => {
      try{
        setOptions(adhesions)
        setContract(adhesions[0])
      } catch (error) {
        throw Error('Failed to get datas')
      }
    }
    // Set options once
    if (!options.length) setDatas()
  }, [adhesions, options, setContract, setOptions])


  return (
    <Select
      className={classNames(style.select, className)}
      onChange={onChange}
      DropdownIndicator={options.length > 1}
      isSearchable={false}
      isDisabled={options.length < 2}
      options={options.map( opt => ({
        label: <>
          {opt.logo?.startsWith('http')
            ? <span className={style.logo}><img src={opt.logo} alt='logo' /></span>
            : opt.logo
              ? <span className={style.logo} dangerouslySetInnerHTML={{__html: opt.logo}}></span>
              : <span className={style.logo}><MainLogo styles={{fill: '#000093'}} /></span>
          }
          {opt.contractTypeName}
        </>,
        value: {
          contractTypeId: opt.contractTypeId,
          partnerId: opt.partnerId,
          distributorId: opt.distributorId
        }
      }))}
      value={<>
        {logo?.startsWith('http')
          ? <span className={classNames(style.logo, style.main)}><img src={logo} alt='logo' /></span>
          : logo
            ? <span className={classNames(style.logo, style.main)} dangerouslySetInnerHTML={{__html: logo}}></span>
            : <span className={classNames(style.logo, style.main)}><MainLogo styles={(displayName || color) && {fill: '#000093'}} /></span>
        }
        {displayName && contractTypeName}
      </>}
      styles={{
        ...styles,
        control:{
          border: options.length < 2 && 'none'
        },
        menu:{
          whiteSpace: 'nowrap',
          width: 'fit-content'
        }
      }}
    />
  )
}

export default CoLabelSwitch
